import React, { useRef } from 'react'
import { Column } from 'components/common/layout'
import { Modal } from 'components/common/modal'
import { Button } from 'components/common/button'
import { MediumText, SemiBoldText } from 'components/common/text'
import { DashboardPosition } from 'types/common'
import { DashboardPositionStore } from 'stores/dashboard/dashboard-position'
import styled from 'styled-components'
import { theme } from 'infra/theme'
import { Card } from 'components/common/card'
import { DashboardPositionFormLocation } from 'containers/dashboard/positions/position-form-location'
import { DashboardPositionFormSalary } from 'containers/dashboard/positions/position-form-salary'
import { DashboardPositionFormCareer } from 'containers/dashboard/positions/position-form-career'
import { displayPositionName } from 'utils/displays'
import { observer } from 'mobx-react'
import { MyLink } from 'components/common/link'

export const PositionInfoFillModal: React.FC<{
  position: DashboardPosition
  onClose: () => void
}> = observer(({ position, onClose }) => {
  const store = useRef(new DashboardPositionStore(position)).current

  return (
    <Modal width={560} onClose={onClose} disableBackgroundClick>
      <Content>
        <Center style={{ gap: 12 }}>
          <SemiBoldText style={{ fontSize: theme.fontSize.h4 }}>
            채용 공고에 비어있는 필수 정보를 입력해주세요
          </SemiBoldText>
          <MediumText style={{ color: theme.color.gray1 }}>
            구체적인 채용 조건을 알려주시면 더 적합한 인재들을 만날 수 있어요!
          </MediumText>
        </Center>
        <Center style={{ gap: 16, width: '100%' }}>
          <MyLink
            href={`/dashboard/positions?positionId=${position.id}`}
            newTab
          >
            <PositionTitle>
              {displayPositionName(
                position.name,
                position.careerType?.name || '',
                position.experienceRange,
              )}
            </PositionTitle>
          </MyLink>
          <FormCard>
            <DashboardPositionFormCareer store={store} />
            <DashboardPositionFormLocation store={store} />
            <DashboardPositionFormSalary store={store} />
          </FormCard>
        </Center>
        <ButtonContainer>
          <Button
            onClick={async () => {
              const isSuccess = await store.savePositionHandler()
              if (isSuccess) onClose()
            }}
          >
            채용 공고 저장하기
          </Button>
        </ButtonContainer>
      </Content>
    </Modal>
  )
})

const Center = styled(Column)`
  align-items: center;
`

const Content = styled(Center)`
  padding: 32px 24px 0;
  gap: 40px;
  max-height: 800px;
  justify-content: start;
`

const PositionTitle = styled(SemiBoldText)`
  font-size: ${(p) => p.theme.fontSize.h5};
  text-align: center;
  color: ${(p) => p.theme.color.black4};
  :hover {
    text-decoration: underline;
  }
`

const FormCard = styled(Card)`
  gap: 32px;
  width: 100%;
  background-color: ${(p) => p.theme.color.background};
  padding: 20px;
`

const ButtonContainer = styled(Center)`
  position: sticky;
  bottom: 0;
  padding: 16px 0;
  width: 100%;
  gap: 12px;
  background-color: ${(p) => p.theme.color.white1};
`
